import { gameModule } from "../games/registry";

export function GameBadge({ gameId }: { gameId: string }) {
  const game = gameModule(gameId);
  return <span className="game-badge">{game?.shortName ?? gameId}</span>;
}
